import { filter, find, get } from 'lodash';

interface UserForGetFirstActiveContact {
  readonly contact?: unknown[] | unknown;
  readonly doNotContact?: unknown;
}

/**
 * Returns all contacts archived of a user or patient
 * @category Getters
 * @category User
 */
export const allContactsArchived = <T extends UserForGetFirstActiveContact>(
  user: T | null,
) => {
  if (!user || !user?.contact) {
    return false;
  }
  return !find(
    user.contact as object,
    (c) => get(c, 'active') && !get(c, 'archived'),
  );
};

/**
 * Returns the first active contact of a user or patient
 * @category Getters
 * @category User
 */
export function getFirstActiveContact<T extends UserForGetFirstActiveContact>(
  user: T | null,
) {
  if (!user || !Object.prototype.hasOwnProperty.call(user, 'contact')) {
    return;
  }
  const { doNotContact, contact } = user;
  if (doNotContact) {
    return {
      value: 'Do Not Contact',
      type: 'donotcontact',
    };
  }
  if (allContactsArchived(user)) {
    return {
      value: 'Invalid Contact',
      type: 'donotcontact',
    };
  }
  const items = filter(contact as object, 'active');
  return (
    find(items, { type: 'sms' }) ||
    find(items, { type: 'email' }) ||
    find(items, { type: 'voice' }) ||
    find(items, { type: 'whatsapp' })
  );
}
